import { MEMBERSHIP_TYPE_OPTIONS, PAYMENT_STATUS_OPTIONS } from '../services/financeService';

export const getMembershipTypeLabel = (value) =>
  MEMBERSHIP_TYPE_OPTIONS.find((option) => option.value === value)?.label || value || '—';

export const getPaymentStatusLabel = (value) =>
  PAYMENT_STATUS_OPTIONS.find((option) => option.value === value)?.label || value || '—';

export const formatFinanceCurrency = (amount, currency = 'TZS') =>
  new Intl.NumberFormat('en-TZ', {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  }).format(Number(amount || 0));

export const formatFinanceDate = (value) => {
  if (!value) return '—';
  try {
    return new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    }).format(new Date(value));
  } catch {
    return value;
  }
};

export const getRecordDisplayDate = (record) =>
  record?.paidAt || record?.dueDate || record?.createdAt;

export const computeEntityFinancialTotals = (records = []) => {
  let totalPaid = 0;
  let totalOutstanding = 0;

  records.forEach((record) => {
    const amount = Number(record.amount || 0);
    if (record.paymentStatus === 'paid') {
      totalPaid += amount;
      return;
    }
    if (record.paymentStatus === 'partial') {
      totalPaid += amount * 0.5;
      totalOutstanding += amount * 0.5;
      return;
    }
    if (!['waived', 'refunded'].includes(record.paymentStatus)) {
      totalOutstanding += amount;
    }
  });

  return {
    totalPaid,
    totalOutstanding,
    totalToBePaid: totalOutstanding,
    recordCount: records.length,
  };
};

export const paymentStatusTone = (status) => {
  if (status === 'paid') return 'text-success';
  if (status === 'overdue') return 'text-destructive';
  if (status === 'partial' || status === 'pending') return 'text-warning';
  return 'text-muted-foreground';
};
